import { types } from 'mobx-state-tree';

export default types.model('OperationHours', {
  dayOfWeek: types.string,
  hours: types.string,
});
